export const getBuildVariant = () => window.BUILD_VARIANT;
